import { jsx as _jsx } from "react/jsx-runtime";
import * as RadixToggleGroup from '@radix-ui/react-toggle-group';
import { cn } from '../../lib/utils';
function ToggleGroup(param) {
    let { value, onChange, availableValues } = param;
    return /*#__PURE__*/ _jsx(RadixToggleGroup.Root, {
        type: "single",
        value: value,
        onValueChange: onChange,
        "aria-label": "Toggle group",
        className: "inline-flex rounded-lg bg-transparent border border-muted p-1 max-h-[36px] items-center",
        children: availableValues.map((item)=>/*#__PURE__*/ _jsx(RadixToggleGroup.Item, {
                value: item.value,
                "aria-label": item.label,
                className: cn('h-[26px] w-fit min-w-[90px] px-2 py-0.5 rounded-lg', 'cursor-pointer transition-all duration-200', 'text-xs font-medium', 'hover:bg-accent/50', 'data-[state=on]:bg-accent-turquoise data-[state=on]:text-white data-[state=on]:shadow-sm', 'data-[state=off]:text-muted-foreground', 'focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2'),
                children: item.label
            }, item.value))
    });
}
export { ToggleGroup };
